import { LanguageEnum } from '@/constant';
import { AuthSelectors } from '@/stores';
import { LanguageActions, LanguageSelectors } from '@/stores/language';
import { MyPageSelectors } from '@/stores/my-page';
import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import i18next from 'i18next';

export const useLanguage = () => {
	const language = useSelector(LanguageSelectors.selectLanguage);
	const dispatch = useDispatch();

	const onChangeLanguage = useCallback(
		(lang: LanguageEnum) => {
			dispatch(LanguageActions.changeLanguageRequest({ language: lang }));
			i18next.changeLanguage(lang);
		},
		[language]
	);

	return {
		onChangeLanguage,
		language,
	};
};

export const useSetLanguage = () => {
	const logged = useSelector(AuthSelectors.selectLogged);
	const { isForeignRole } = useSelector(MyPageSelectors.selectDataMyPage);
	const lang = useMemo(
		() => (isForeignRole ? LanguageEnum.EN : LanguageEnum.KO)?.toLowerCase(),
		[isForeignRole]
	);

	useEffect(() => {
		if (!logged) return;

		i18next.changeLanguage(lang);
	}, [logged, lang]);
};
